import { orderStatus } from 'utils/orderStatus';

export default {
    [orderStatus[0]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    'PA-All Pending': [
        {
            name: 'Manager Approval',
            status: 'hourglass',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'hourglass',
        },
    ],
    'PA-Manager Approved': [
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'hourglass',
        },
    ],
    'PA-DevopsOwner Approved': [
        {
            name: 'Azure Devops Owner Approval',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'hourglass',
        },
    ],
    'PA-Only Manager': [
        {
            name: 'Manager Approval',
            status: 'hourglass',
        },
    ],
    [orderStatus[1]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'hourglass',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    [orderStatus[2]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Cancelled',
            status: 'clear',
        },
    ],
    [orderStatus[3]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'clear',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    'DevopsOwner Rejected': [
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'clear',
        },
    ],
    'Manager Rejected': [
        {
            name: 'Azure Devops Owner Approval',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'clear',
        },
    ],
    'Manager Rejected-DevopsOwner Pending': [
        {
            name: 'Manager Approval',
            status: 'clear',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'wait',
        },
    ],
    'DevopsOwner Rejected-Manager Pending': [
        {
            name: 'Azure Devops Owner Approval',
            status: 'clear',
        },
        {
            name: 'Manager Approval',
            status: 'wait',
        },
    ],
    [orderStatus[4]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'done',
        },
        {
            name: 'Completed',
            status: 'done',
        },
    ],
    [orderStatus[5]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'priority-high',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    'Manager Returned': [
        {
            name: 'Manager Approval',
            status: 'priority-high',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'wait',
        },
    ],
    'DevopsOwner Returned': [
        {
            name: 'Azure Devops Owner Approval',
            status: 'priority-high',
        },
        {
            name: 'Manager Approval',
            status: 'wait',
        },
    ],
    'Manager Approved DevopsOwner Returned': [
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'priority-high',
        },
    ],
    'Manager Returned DevopsOwner Approved': [
        {
            name: 'Azure Devops Owner Approval',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'priority-high',
        },
    ],
    [orderStatus[6]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'Azure Devops Owner Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'done',
        },
        {
            name: orderStatus[4]?.name,
            status: 'hourglass',
        },
    ],
};
